module.exports = __webpack_public_path__ + "img/LaBase-Latte-Amaretto-600px.34d5b0b4.jpg";